import React from "react";
import { Helmet } from "react-helmet";
import { useAccountID, usePublishMonths } from "../../store/account";

const dateFormat = Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "long"
}).format;

export default function ExportStats() {
    const accountID = useAccountID();
    const { data: months } = usePublishMonths(accountID);

    return (
        <>
            <Helmet>
                <title>Export Stats - Podtrac</title>
            </Helmet>
            <h1>Export Stats</h1>
            <p>Generate an export file of daily episode statistics for all of your shows.
                Choose the month to export below.</p>
            <form method="post" action={`/__/${ accountID }/podcasts/ExportStatsEpisode`}>
                <label>
                    Month{" "}
                    <select name="StartMonth" defaultValue={months?.[1]?.publishMonth}>
                        {months?.map(m => <option key={m.publishMonth} value={m.publishMonth}>
                            {dateFormat(new Date(m.publishMonth))}
                        </option>)}
                    </select>
                </label>{" "}
                <button type="submit">Export</button>
            </form>
        </>
    );
}
